import { useTranslation } from "react-i18next";
import ViewAllProductsDataTable from "../admin/view-all-products-datatable";
import { Suspense, useEffect, useRef, useState } from "react";
import AppLoading from "../app-loading/app-loading";
import { Toast } from "primereact/toast";
import { POSProductModel } from "../../models/all-user/edit-user-model";
import posService from "../../services/pos/pos.service";
import { TabView, TabPanel } from "primereact/tabview";
import RawMaterialMovementSearch from "./rawMaterial-movement-search";
import { RawMaterialMovementLogTable } from "./RawMaterial-movement-log";
import { RawMaterialMovementSummary } from "./RawMaterial-movement-summary";

const RawMaterialMovementMain = () => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [loading, setLoading] = useState(false);
  const [logData, setLogData] = useState<any[]>([]);
  const [summaryData, setSummaryData] = useState<any[]>([]);
  
  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} position="top-right" />
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
          <div className="col-12">
            <h5 className="ml-1 mb-0">{t("RawMaterial Movements")}</h5>
          </div>
          <div className="col-12">
            <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                    <RawMaterialMovementSearch  setLoading={setLoading}  onSearch={(data) => setLogData(data)} onSummary={(data) => setSummaryData(data)}/>
            </div>
          </div >
          <div className="col-12">
          <TabView>
          <TabPanel header="Movement Log">
            <RawMaterialMovementLogTable data={logData} loading={loading} />
          </TabPanel>
          <TabPanel header="Summary View">
            <RawMaterialMovementSummary data={summaryData} loading={loading} />
          </TabPanel>
        </TabView>
            </div>
        </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default RawMaterialMovementMain;
